export default "__VITE_ASSET__CQXPVjpP__"